export function HealthCheck() {
  return (
    <div>
      <h3>Health Check</h3>
    </div>
  );
}
